import { render, staticRenderFns } from "./scPlayer.vue?vue&type=template&id=54490263&scoped=true&"
import script from "./scPlayer.vue?vue&type=script&lang=js&"
export * from "./scPlayer.vue?vue&type=script&lang=js&"
import style0 from "./scPlayer.vue?vue&type=style&index=0&id=54490263&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54490263",
  null
  
)

export default component.exports